import Vue from 'vue';
import Router from 'vue-router';
import ReceiptView from './views/receipt.vue';
import LoginView from './views/login.vue';

Vue.use(Router);

export default new Router({
	mode: 'hash',
	routes: [
		{
			path: '/receipt',
			name: 'receipt',
			component: ReceiptView
		},
		{
			path: '/login',
			name: 'login',
			component: LoginView
		}
		// {
		//   path: '/',
		//   name: 'home',
		//   component: Home
		// },
		// {
		//   path: '/about',
		//   name: 'about',
		//   // route level code-splitting
		//   // this generates a separate chunk (about.[hash].js) for this route
		//   // which is lazy-loaded when the route is visited.
		//   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
		// }
	]
});
